import { render, staticRenderFns } from "./ExportProductSalesDetail.vue?vue&type=template&id=bfdba010&"
import script from "./ExportProductSalesDetail.vue?vue&type=script&lang=js&"
export * from "./ExportProductSalesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports